<template>
  <div class="preloader" style="text-align: center"
       :style="{'font-size': `${fontSize}px`,
       'margin-top': `${fontSize * 2}px`,
       'margin-bottom': `${fontSize * 2}px`,}">
    <i class="el-icon-loading"></i>
  </div>
</template>

<script>
  export default {
    props: ['size', 'height'],
    computed: {
      fontSize() {
        return this.size || 30
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Preloader/index.vue